<template>
    <b-row>
        <b-col md="4">
            <b-form-group
                label="Limit"
                :label-class="['secondary-label', {'d-none': index > 0}]"
                class="mb-0"
                :invalid-feedback="errorMessage(method + '.'+ type + '.' + displayIndex({
                    'method': method,
                    'index': index,
                    'type': type
                }) + '.limit')"
                :state="isValid(method + '.'+ type + '.' + displayIndex({
                    'method': method,
                    'index': index,
                    'type': type
                }) + '.limit')">
                <b-form-input type="number" min="0" v-model="values.limit"
                    @keyup.native="isAllowed()"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col md="8">
            <b-form-group
                label="Frequency"
                :label-class="['secondary-label', {'d-none': index > 0}]"
                class="mb-0"
                :invalid-feedback="errorMessage(method + '.'+ type + '.' + displayIndex({
                    'method': method,
                    'index': index,
                    'type': type
                }) + '.frequency')"
                :state="isValid(method + '.'+ type + '.' + displayIndex({
                    'method': method,
                    'index': index,
                    'type': type
                }) + '.frequency')">
                <b-form-select id="earn_frequency"
                    :options="frequency"
                    v-model="values.frequency">
                </b-form-select>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "LimitFequency",
    props: ["form", "frequency", "index", "values", "type", "method", "addIndex"],
    computed: {
        ...mapState("mechanicsCapping", ["errors"])
    },
    methods: {
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },

        displayIndex(param) {
            if (param.method === "add") {
                return Number(param.index - 1);
            } else {;
                return param.index;
            }
        },

        isAllowed(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            let evt_val = parseInt(evt.target.value, 10);
            if (evt_val == "99999") {
                if (charCode != 8) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else if (evt_val > "99999") {
                evt.target.value = "99999";
            }
        }
    }
};
</script>
